import { useAuth } from '../contexts/AuthContext';

/**
 * True when the current user's org is on the derived workflow **eligibility** model
 * (the `workflow.eligibility` feature flag is enabled), false on the legacy **promotion**
 * model. Single source for the per-org model split across the web UI, so copy, badges,
 * and filters that differ between the two models don't drift out of sync.
 *
 * Flag OFF (default) → promotion wording/behavior ("promoted"); flag ON → eligibility.
 */
export function useEligibilityModel(): boolean {
  const { user } = useAuth();
  return user?.features?.workflowEligibility ?? false;
}
